
import { defineComponent } from "vue";
import Card from "@/components/Card.vue";
import Hairline from "@/components/Hairline.vue";

export default defineComponent({
    components: { Card, Hairline },
});
